/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ModelCommonResponse, ModelMoveAPIRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class MoveApi<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description move api from one project to another
   *
   * @tags api
   * @name MoveApiCreate
   * @summary move api from one project to another
   * @request POST:/moveApi
   */
  moveApiCreate = (request: ModelMoveAPIRequest, params: RequestParams = {}) =>
    this.request<ModelCommonResponse, any>({
      path: `/moveApi`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
